module.exports = __webpack_public_path__ + "img/number3.c5b13250.svg";